export const ageMethod = "age nearest";
export const gateway = "https://scoop-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/scoop";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzY29vcCIsIm5hbWUiOiJzY29vcCIsImlhdCI6MTc3OTkyNTk0MiwiZXhwIjoxOTM3NzEzOTQyfQ.6OKuD4pPpDfq2CqlDYhHGq-fmkwJ3Tzflx0Vuakddto";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"scoop.link.wawanesalife.com": {
		a: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_scoop",
			brands: [
				"scoop.link.wawanesalife.com",
			],
			broker: "scoop",
			broker_formatted_name: "Scoop Financial",
			email: "customercare@scoopfinancial.ca",
			environment: "stable",
			environment_id: "stable",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1-888-922-8422",
			photos: [
				"photo1.png",
			],
			privacyLink: "https://scoopfinancial.ca/privacy/",
			website: "https://scoopfinancial.ca/",
			scope: "scoop#branding#scoop.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "scoop.link.wawanesalife.com",
		},
		b: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_scoop",
			brands: [
				"scoop.link.wawanesalife.com",
			],
			broker: "scoop",
			broker_formatted_name: "Scoop Financial",
			email: "customercare@scoopfinancial.ca",
			environment: "stable",
			environment_id: "stable",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1-888-922-8422",
			photos: [
				"photo1.png",
			],
			privacyLink: "https://scoopfinancial.ca/privacy/",
			website: "https://scoopfinancial.ca/",
			scope: "scoop#branding#scoop.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "scoop.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 18:52:22 GMT-0500 (Central Daylight Time)
